import React, { Component } from "react";
import { Redirect, Link } from "react-router-dom";
import { withTranslation } from "react-i18next";

class HeaderAccount extends Component {
  state = {
    dropdownAcc: this.props.dropdownAcc,
    activeMenu: null,
    defaultMenu: null,
  };
  dropdownAccClick = () => {
    this.setState({ dropdownAcc: !this.state.dropdownAcc });
  };
  handleClick = (e) => {
    this.setState({
      activeMenu: e.target.innerHTML,
      defaultMenu: null,
      dropdownAcc: false,
    });
  };
  componentDidMount() {
    const userMenu = localStorage.getItem("userMenu");
    console.log("receive userMenu ", userMenu);
    this.setState({
      dropdownAcc: this.props.dropdownAcc,
      defaultMenu: userMenu,
    });
  }
  render() {
    const isAuth = this.props.isAuth;
    if (isAuth === "0") {
      return <Redirect to={"/logout"} />;
    }

    return (
      <React.Fragment>
        <div className="d-block d-sm-none">&nbsp;</div>
        <ul className="nav-tab d-none d-sm-block">
          <li>
            <Link data-menu="profile" to="/profile" onClick={this.handleClick}>
              {this.props.t("HeaderAccount.link_profil")}
            </Link>
          </li>
          <li>
            <Link
              data-menu="transaction"
              to="/transaction/tree"
              onClick={this.handleClick}
            >
              {this.props.t("HeaderAccount.link_transaksi")}
            </Link>
          </li>
          {/* <li>
            <Link to="/" onClick={this.handleClick}>
              {this.props.t("HeaderAccount.link_marketplace")}
            </Link>
          </li> */}
        </ul>
      </React.Fragment>
    );
  }
}
export default withTranslation()(HeaderAccount);
